import React from 'react';
import { getConfig } from '../../../config';
import { DeployArea } from '../../../model';
import { GameEnvRegion, IGameEnvModel } from '../../../model/api-modules/env';
import { getLocalGameFilterByGame } from '../game-filter/lib';
import getFormatMessage from '../../../locales/get-format-message';

export const getGameEnvRegionName = (region: string): string => {
  for (const item of getGameEnvRegionEntry()) {
    if (item[1] === region) {
      return item[0];
    }
  }
  return '';
};

export const getGameEnvRegionEntry = () => {
  return getConfig().gameConfig.region;
};

export const getGameEnvTypeOptions = () => {
  const deployArea: DeployArea = getConfig()?.deployArea;
  const isWoa = deployArea === DeployArea.woa;
  const list: { label: React.ReactNode | string; value: GameEnvRegion }[] = [];
  getConfig().gameConfig.region.forEach(([label, value]) => {
    if (value === GameEnvRegion.DevCloud) {
      if (isWoa) {
        list.push({
          label: label || '',
          value: value || '',
        });
      }
    } else {
      let itemLabel: React.ReactNode | string = label;
      if (isWoa && value === GameEnvRegion.Woa) {
        itemLabel = (
          <>
            <span>{label}</span>
            <span
              style={{
                display: 'inline-block',
                width: '40px',
                height: '20px',
                background: '#F7BA1E1A',
                color: '#F7BA1E',
                textAlign: 'center',
                lineHeight: '20px',
                borderRadius: '4px',
                marginLeft: '4px',
                fontSize: '12px',
              }}
            >
              {getFormatMessage('promo')}
            </span>
          </>
        );
      }
      list.push({
        label: itemLabel,
        value: value as GameEnvRegion,
      });
    }
  });

  return list;
};

export const filterCurAreaEnvList = (envs: ReadonlyArray<IGameEnvModel>) => {
  return envs.filter((v) =>
    getConfig()
      .gameConfig.region.map((v) => v[1])
      .includes(v.Region)
  );
};

export const getCurrentDefaultEnvID = (
  gameID: string,
  envs: ReadonlyArray<IGameEnvModel>
) => {
  if (!envs.length) {
    return 0;
  }
  const localEnvID = getLocalGameFilterByGame(gameID);
  const envItem = envs.find((item) => item.id === localEnvID);
  return envItem?.id || envs[0].id;
};
